module.exports = [{"href":"/our_fish","text":"Our Fish"},{"href":"/gallery","text":"Gallery"},{"href":"/rules","text":"Rules"},{"href":"/deals","text":"Deals","className":"deals_link"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/menu_items.json
// module id = 849
// module chunks = 0